export default __webpack_public_path__ + "static/media/error imagen.7380b934.svg";